import { enqueueSnackbar } from 'actions';

import {
	GetOperatorsRequest,
	CreateOperatorRequest,
	DeleteOperatorRequest,
	GetOperatorRequest,
	UpdateImageRequest,
	DeleteProjectRequest,
	CreateProjectRequest,
	UpdateOperatorRequest
} from '../requests/OperatorsRequests.js';

export const GET_OPERATORS = 'GET_OPERATORS';
export const TOGGLE_ADD_OPERATOR_DIALOG = 'TOGGLE_ADD_OPERATOR_DIALOG';
export const SET_FORM_STATE = 'SET_FORM_STATE';
export const NAVIGATE_DETAILS = 'NAVIGATE_DETAILS';
export const GET_OPERATOR = 'GET_OPERATOR';
export const TOGGLE_ADD_PROJECT_DIALOG = 'TOGGLE_ADD_PROJECT_DIALOG';

const onGetOperators = (value) => ({
	type: GET_OPERATORS,
	operators: value
});

const onToggleAddOperatorDialog = (openAddOperatorDialog) => ({
	type: TOGGLE_ADD_OPERATOR_DIALOG,
	openAddOperatorDialog,
});

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onNavigateDetails = (value) => ({
	type: NAVIGATE_DETAILS,
	detailsOperatorId: value
});

const onGetOperator = (value) => ({
	type: GET_OPERATOR,
	operator: value
});

const onToggleAddProjectDialog = (openAddProjectDialog) => ({
	type: TOGGLE_ADD_PROJECT_DIALOG,
	openAddProjectDialog,
});

export const GetOperators = () => async (dispatch) => {
	await GetOperatorsRequest().then(response => {
		dispatch(onGetOperators(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleAddOperatorDialog = (openAddEditOperatorDialog) => (dispatch) => {
	dispatch(onToggleAddOperatorDialog(openAddEditOperatorDialog));
};

export const CreateOperator = (data) => async (dispatch) => {
	await CreateOperatorRequest(data).then(response => {
		dispatch(enqueueSnackbar({ message: 'New operator created!', options: { key: new Date().getTime() + Math.random(), variant: 'success' } }));
		dispatch(GetOperators());
		dispatch(ToggleAddOperatorDialog(false));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DeleteOperator = (data) => async (dispatch) => {
	await DeleteOperatorRequest(data).then(response => {
		dispatch(GetOperators());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const NavigateDetails = (value) => (dispatch) => {
	dispatch(onNavigateDetails(value));
};

export const GetOperator = (operatorId) => async (dispatch) => {
	await GetOperatorRequest(operatorId).then(response => {
		dispatch(onGetOperator(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UpdateImage = (operator) => async (dispatch) => {
	await UpdateImageRequest(operator).then(response => {
		dispatch(GetOperator(operator.id));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DeleteProject = (projectId, operatorId) => async (dispatch) => {
	await DeleteProjectRequest(projectId).then(response => {
		dispatch(GetOperator(operatorId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleAddProjectDialog = (openAddEditProjectDialog) => (dispatch) => {
	dispatch(onToggleAddProjectDialog(openAddEditProjectDialog));
};

export const CreateProject = (data) => async (dispatch) => {
	await CreateProjectRequest(data).then(response => {
		dispatch(enqueueSnackbar({ message: 'New project created!', options: { key: new Date().getTime() + Math.random(), variant: 'success' } }));
		dispatch(GetOperator(data.operatorId));
		dispatch(ToggleAddProjectDialog(false));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UpdateOperator = (operator) => async (dispatch) => {
	await UpdateOperatorRequest(operator).then(response => {
		dispatch(enqueueSnackbar({ message: 'Operator updated!', options: { key: new Date().getTime() + Math.random(), variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
